import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Representative  {
    _originalTypeClassName = "zERP.BO.Representative";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Representative.translate = translateService;
}
this.RepresentativesVisits = [];
this.Id = null;
this.RepresentativeCode = null;
this.RepresentativeCapacity = null;
this.StartDate = null;
this.EndDate = null;
this.ContractNumber = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
RepresentativeCode:any;
RepresentativeCapacity:any;
StartDate:any;
EndDate:any;
ContractNumber:any;
Employee:any;
RepresentativesVisits:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setRepresentativesVisits = ($this, items) => {
                if (items == null) items = [];
                if ($this.RepresentativesVisits == null) $this.RepresentativesVisits = [];

                const copyItems = Common.cloneObject(items);

                while ($this.RepresentativesVisits.length > 0) {
                    Domain.Representative.removeRepresentativesVisits($this, $this.RepresentativesVisits[0]);
                }

                Domain.Representative.addManyRepresentativesVisits($this, copyItems);
            }
static addManyRepresentativesVisits = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Representative.addRepresentativesVisits($this, items[i]);
                }
            }
static addRepresentativesVisits = ($this, item) => {
                if ($this.RepresentativesVisits == null) $this.RepresentativesVisits = [];
                if (item == null || $this.RepresentativesVisits.indexOf(item) > -1) return;
                $this.RepresentativesVisits.push(item);
if (item.Representative != $this) {
Domain.RepresentativesVisits.setRepresentative(item, $this);
}
}
static addRangeRepresentativesVisits = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Representative.addRepresentativesVisits($this, item));
            }
static removeRepresentativesVisits = ($this, item) => {
                if ($this == null || $this.RepresentativesVisits == null || $this.RepresentativesVisits.indexOf(item) === -1) return;
                var _index = $this.RepresentativesVisits.indexOf(item);
                $this.RepresentativesVisits.splice(_index, 1);
item.Representative = null;
}
static clearRepresentativesVisits = ($this) => { $this.RepresentativesVisits = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}